/* eslint-disable class-methods-use-this */
import {
  Module, VuexModule, getModule, Action, Mutation,
} from '@compassdigital/vuex-module-decorators';
import jwtDecode from 'jwt-decode';
import { DateTime } from 'luxon';
import store from '@/store';
import AppModule from '@/store/modules/app';
import UserModule from '@/store/modules/user';
import SystemModule from '@/store/modules/system';
import NotificationModule from '@/store/modules/notification';

@Module({
  dynamic: true,
  name: 'lifecycle',
  store,
})
class LifeCycleModule extends VuexModule {
  public initialized: boolean = false;

  @Mutation
  public setInitialized(val: boolean) {
    this.initialized = val;
  }

  @Action
  public async init() {
    this.setInitialized(true);
    if (!AppModule.accessToken) {
      throw new Error('no access token');
    }
    if (AppModule.accessToken) {
      const decode: { exp: number } = jwtDecode(AppModule.accessToken);
      const expiry = DateTime.fromSeconds(decode.exp);
      if (expiry > DateTime.local()) {
        await AppModule.authenticate();
        try {
          await Promise.all(
            [
              SystemModule.fetchMarkets(),
              SystemModule.fetchSectors(),
              SystemModule.fetchSettings(),
              NotificationModule.fetchNotifications(),
            ],
          );

          NotificationModule.startNotificationFetch();
        } catch (err) {
          console.log('could not load settings');
        }
      }
    }
  }

  @Action
  public async terminate(path?: string) {
    AppModule.logout();
    NotificationModule.stopNotificationFetch();
    this.setInitialized(false);
  }
}

export default getModule(LifeCycleModule);
